(() => {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  // Purchase feedback is driven by a successful cart response, including keyboard submissions.
  document.addEventListener('antarmada:cart-added', () => {
    if (reduce.matches) return;
    const cart = document.getElementById('cart-icon-bubble');
    cart?.animate?.([{ transform: 'scale(1)' }, { transform: 'scale(1.08)' }, { transform: 'scale(1)' }],
      { duration: 260, easing: 'ease-out' });
  });
})();
